


export const getDonatePlugin = (Clappr)=>{


//QualitySelector
 
return Clappr.UICorePlugin.extend({
  name: 'donate_plugin',
  
  version: '1.0',

  
  bindEvents: function () {
 
      this.listenTo(this.core, Clappr.Events.CORE_ACTIVE_CONTAINER_CHANGED, this.reload);
      this.listenTo(this.core.mediaControl, Clappr.Events.MEDIACONTROL_RENDERED, this.render) 
  },

  unBindEvents: function () {
      var currentPlayback = this.core.activePlayback;

 
      this.stopListening(this.core, Clappr.Events.CORE_ACTIVE_CONTAINER_CHANGED);
      this.stopListening(this.core.mediaControl, Clappr.Events.MEDIACONTROL_RENDERED);
     
  },


shouldRender: function () {
      if (!this.core.activeContainer) return false;
var currentPlayback = this.core.activePlayback;
      if (!currentPlayback) return false;
	return true;
   
},

   reload: function () {
      this.unBindEvents();
      this.bindEvents();
 
  },
  render: function () {

	 
	 if (this.shouldRender()) {
         // this.$el.html(this.template());
	 this.core.mediaControl.$('.media-control-layer').parent().parent().append(this.el); //

	this.updateShowDonateView()
	}
	return this
     
  },

  template: function () {
	  
	var template = `    <div class="donate">
                 <div donate-button class="donate-button"><div>DONATE</div></div>
              </div>
`
	
return template

	
 
  },
  
  attributes: {
      'class': 'donates',
      'data-donates': ''
  },

  events: {
      'click [donate-button]': 'onDonateButtonClick'
  },
  updateNumView: function(){
	

		var elem = this.$('.donates')
		if(elem){
			elem.text(this.live_num)
		}
	},
 updateShowDonateView: function(){
		if(this.show_plugin){
 			this.$el.html(this.template());
		}else {
			this.$el.html('');
		}
		//this.$('.live-viewers').text(this.live_num)
	},
   
  setDonates: function(show){
	this.show_plugin = show
	this.updateShowDonateView()
	},


 onDonateButtonClick: function(){
	if(this.click_cb !== null){
		this.click_cb()
        }
  },
  
  setClickCb: function(cb){
	this.click_cb = cb
	},
  click_cb: null,
 show_plugin: false,

});

//Object.defineProperty(QualitySelector, 'name', { value: 'QualitySelector' });
/*
Clappr.Player.prototype.setLiveViewersVisibility = function (visible) {
  var liveViewers = this.getPlugin('live_viewers');
 
};
 

Clappr.Player.prototype.setLiveViewersNumber = function (num) {
  var liveViewers = this.getPlugin('live_viewers');
	
 	liveViewers.setActualNum(num)
};
 
*/
}
